var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#ff7f2a",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M0.84 1019.97 C0.84 1002.4 15.09 988.13 32.62 988.13 C50.16 988.13 64.41 1002.4 64.41 1019.97 C64.41 1037.55 50.16 1051.82 32.62 1051.82 C15.09 1051.82 0.84 1037.55 0.84 1019.97 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M18.53 1019.65 C18.53 1012.04 24.6 1005.86 32.08 1005.86 C39.55 1005.86 45.62 1012.04 45.62 1019.65 C45.62 1027.25 39.55 1033.43 32.08 1033.43 C24.6 1033.43 18.53 1027.25 18.53 1019.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.007503 0 0 0.992553 23.86096 1005.811889)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.3
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.56
  }, "5"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5B);
export default __webpack_public_path__ + "static/media/5B.e28ce9271450a69b1d64040b616dcfb2.svg";
export { ForwardRef as ReactComponent };